import * as React from "react";
import { cn } from "../../lib/utils";

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type = "text", ...props }, ref) => {
		return (
			<input
				ref={ref}
				type={type}
				className={cn(
					"w-full bg-white dark:bg-white/[0.03] " +
						"border border-gray-200 dark:border-white/[0.08] " +
						"rounded-md px-2.5 py-1.5 text-xs " +
						"text-gray-900 dark:text-gray-100 " +
						"placeholder-gray-400 dark:placeholder-gray-500 " +
						"focus:outline-none focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500/50 " +
						"transition-[border-color,box-shadow] duration-150",
					className,
				)}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";

export { Input };
